module.exports = __webpack_public_path__ + "img/xinxijianshe3.23074330.png";